// @flow
import type { Saga } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "../../actions";
import { Api } from '../../../utils/api';

const fetchNotificationsDraft = function* fetchNotificationsDraftSaga(
	{ payload: { team_id } }
): Saga<void> {
	try {
		const {
			result
		} = yield call(Api.Notifications.notifications_draft, { team_id });

		if (result) {
			yield put(actions.fetchNotificationsDraftSuccess(result));
		}
		else {
			yield put(actions.fetchNotificationsDraftFailed());
		}
	}
	catch (error) {
		console.log(error);
		yield put(actions.userLogoutFailed(error.message));
	}
};

const fetchNotificationBar = function* fetchNotificationBarSaga(

): Saga<void> {
	try {
		const response = yield call(Api.Notifications.notification_bar);
		if(response){
			console.log(response, 'payload');
			yield put(actions.fetchNotificationBarSuccess(response));
		}

	}
	 catch (error) {
		console.log(error);
	}
};

export function* notificationsRootSaga(): Saga<void> {
	yield takeLatest(actions.fetchNotificationsDraft, fetchNotificationsDraft);
	yield takeLatest(actions.fetchNotificationBar, fetchNotificationBar);
}


// WEBPACK FOOTER //
// ./src/modules/sagas/notifications/index.js